module.exports = __webpack_public_path__ + "img/hxkj-jjfa-2.2d8279a4.svg";